import { render, staticRenderFns } from "./SelectProduct.vue?vue&type=template&id=48030746"
import script from "./SelectProduct.vue?vue&type=script&lang=js"
export * from "./SelectProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports